export enum MotivoRechazo {
  CORTE_LUZ = 0,                // Corte de luz / rotura de bomba en instalación
  DESPERFECTO_UNIDAD = 1,       // Desperfecto de la unidad
  DESVIO_RUTEO = 2,             // Desvío solicitado por ruteo
  FALTA_CAPACIDAD = 3,          // Falta de capacidad
  OTROS = 4,                    // Otros
  PROBLEMAS_CLIMATICOS = 5,     // Problemas climáticos / corte de ruta
  RECHAZO_INCOMPLETA = 6,       // Rechazo cisterna incompleta - sin precinto
  RECHAZO_CALIDAD = 7           // Rechazo por calidad de producto
}
